// ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { sessionManager } from "../context/sessionManager";
import { useEffect, useState } from "react";

export default function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkSession = () => {
      const isValid = sessionManager.isValidSession();
      setIsAuthenticated(isValid);
      
      // Clear session if invalid
      if (!isValid) {
        sessionManager.clearSession();
      }
    };

    checkSession();
    
    // Listen for session expiration
    const handleSessionExpired = () => {
      setIsAuthenticated(false);
    };

    window.addEventListener('session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, []);

  // Show loading while checking
  if (isAuthenticated === null) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{ 
          color: 'white', 
          fontSize: '18px',
          fontWeight: '500'
        }}>
          Checking authentication...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Clear any invalid session data
    localStorage.removeItem("appAuth"); // Remove old auth key
    sessionManager.clearSession();
    
    return <Navigate to="/login" replace />;
  }

  return children;
}